import script from "./QRTemplateSix.vue?vue&type=script&lang=ts&setup=true"
export * from "./QRTemplateSix.vue?vue&type=script&lang=ts&setup=true"

import "./QRTemplateSix.vue?vue&type=style&index=0&id=dc0b7466&scoped=true&lang=css"
/* custom blocks */
import block0 from "./QRTemplateSix.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc0b7466"]])

export default __exports__